import { useState } from "react";
import { http } from "../../api/client";

function BookingForm({ vehicle, onClose, setMessage, message }) {
  const [formData, setFormData] = useState({
    customer_name: "",
    driver_license: "",
    phone: "",
    email: "",
    start_date: "",
    end_date: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...formData, vehicle_id: vehicle.id };

    try {
      await http("/bookings", { method: "POST", body: JSON.stringify(payload) });
      setMessage("✅ Booking submitted successfully!");
    } catch (err) {
      setMessage(`❌ Error: ${err.message}`);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      {["customer_name", "driver_license", "phone", "email"].map((field) => (
        <input
          key={field}
          type={field === "email" ? "email" : "text"}
          placeholder={field.replace("_", " ").replace(/^\w/, (c) => c.toUpperCase())}
          required
          value={formData[field]}
          onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
          className="w-full border border-gray-300 rounded px-3 py-2"
        />
      ))}
      {["start_date", "end_date"].map((dateField) => (
        <div key={dateField}>
          <label className="block text-sm font-medium text-gray-600">
            {dateField === "start_date" ? "Start Date:" : "End Date:"}
          </label>
          <input
            type="date"
            required
            value={formData[dateField]}
            onChange={(e) => setFormData({ ...formData, [dateField]: e.target.value })}
            className="w-full border border-gray-300 rounded px-3 py-2"
          />
        </div>
      ))}

      <div className="flex items-center gap-3 mt-4">
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          Submit Booking
        </button>
        <button type="button" onClick={onClose} className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600">
          Cancel
        </button>
      </div>

      {message && (
        <div className="mt-4">
          <p>{message}</p>
          {message.startsWith("✅") && (
            <button
              onClick={onClose}
              className="mt-2 bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
            >
              OK
            </button>
          )}
        </div>
      )}
    </form>
  );
}

export default BookingForm;
